// extracted by mini-css-extract-plugin
export default {"snackbarContainer":"SnackbarMessage_snackbarContainer__ls1T2","text":"SnackbarMessage_text__jgO9A"};